export const counterInitState = 0;
